import React from 'react';
import {Button, Flex, Form, Input} from "antd";
import {MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import IntlMessage from "../../../../../../components/IntlMessage/IntlMessage";
import classes from "../../../Applications/application.module.css";

const Step3Tasks = ({currentStep}) => {
    const {t} = useTranslation();

    return (
        <Flex style={{width: "100%", position: "relative"}} vertical gap={"small"}>
            <Form.List name="opTasks" rules={[{required: currentStep === 2, message: t('requiredField')}]}>
                {(fields, {add, remove}) => (
                    <Flex vertical gap={10}>
                        <IntlMessage id={"tasksEPMQ"}/>
                        {fields.map(({key, name, ...restField}) => (
                            <Flex key={key} gap={"small"} justify={"flex-start"} align={"baseline"}>
                                <Form.Item
                                    {...restField}
                                    name={[name, 'nameRu']}
                                    className={classes.formInputBlock}
                                    rules={[{required: true, message: t('requiredField')}]}
                                >
                                    <Input placeholder={t('nameRu')}/>
                                </Form.Item>
                                <Form.Item
                                    {...restField}
                                    name={[name, 'nameKz']}
                                    className={classes.formInputBlock}
                                    rules={[{required: true, message: t('requiredField')}]}
                                >
                                    <Input placeholder={t('nameKz')}/>
                                </Form.Item>
                                <Form.Item
                                    {...restField}
                                    name={[name, 'nameEng']}
                                    className={classes.formInputBlock}
                                    rules={[{required: true, message: t('requiredField')}]}
                                >
                                    <Input placeholder={t('nameEng')}/>
                                </Form.Item>
                                <MinusCircleOutlined onClick={() => remove(name)}/>
                            </Flex>
                        ))}
                        <Form.Item>
                            <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined/>}>
                                <IntlMessage id={"certificate.addField"}/>
                            </Button>
                        </Form.Item>
                    </Flex>
                )}
            </Form.List>
        </Flex>
    );
};

export default Step3Tasks;
